import { StyledMain } from "./styled";

const Container = ({ children }) => (
    <StyledMain>
        {children}
    </StyledMain>
)
export default Container;